<script>
  export default {
    methods: {
      periodoFechaFrom(value) {
        if (!value) {
          return null;
        }
        const fechaOriginal = this.$moment(value); // Convertir el string de entrada a un objeto moment
        const diaOriginal = fechaOriginal.date();
        let fechaResultado;
        if (diaOriginal <= 28) {
          // Si el día original es 28 o menos, el periodo 'from' es el día 29 del MES ANTERIOR.
          fechaResultado = fechaOriginal.clone().subtract(1, 'month');
        } else {
          // Si el día original es mayor a 28, el periodo 'from' es el día 29 del MES ACTUAL.
          fechaResultado = fechaOriginal.clone();
        }
        // Siempre establecemos el día 29.
        return fechaResultado.set('date', 29).format('YYYY-MM-DD');
      },
      periodoFechaTo(value) {
        if (!value) {
          return null;
        }
        const fechaOriginal = this.$moment(value); // Convertir el string de entrada a un objeto moment
        // Obtener el día del mes de la fecha original
        const diaOriginal = fechaOriginal.date();
        let fechaResultado;
        if (diaOriginal <= 28) {
          // Si el día original es menor a 28, el mes y el año son los mismos.
          fechaResultado = fechaOriginal.clone(); // Usamos .clone() para no modificar fechaOriginal
        } else {
          // Si el día original es mayor a 28, sumamos un mes.
          fechaResultado = fechaOriginal.clone().add(1, 'month');
        }
        // Siempre establecemos el día 28.
        return fechaResultado.set('date', 28).format('YYYY-MM-DD');
      }
    }
  };
</script>
